define([
    'fastdom',
    'Promise'
], function (
    fastdom,
    Promise
) {
    function promisify(fdaction) {
        return function (fn, ctx) {
            return new Promise(function (resolve, reject) {
                fdaction(function () {
                    try {
                        resolve(fn.call(this));
                    } catch (e) {
                        reject(e);
                    }
                }, ctx);
            });
        };
    }

    return {
        read: promisify(fastdom.read.bind(fastdom)),
        write: promisify(fastdom.write.bind(fastdom))
    };
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/lib/fastdom-promise.js
// module id = 63
// module chunks = 0 1 15